import cn from 'classnames';
import * as React from 'react';

import * as styles from './OfferCardSkeleton.css';

function CardSkeleton() {
  return (
    <div className={styles['card']}>
      <div className={cn(styles['gallery'], styles['skeleton'])} />
      <div className={styles['thumbnails']}>
        <div className={cn(styles['thumbnail'], styles['skeleton'])} />
        <div className={cn(styles['thumbnail'], styles['skeleton'])} />
        <div className={cn(styles['thumbnail'], styles['skeleton'])} />
      </div>
      <div className={cn(styles['card-title'], styles['skeleton'])} />
    </div>
  );
}

interface IListingSkeletonProps {
  count: number;
  /** Без плашки заголовка и крестика - когда шапка у шторки настоящая (шторка мультипина) */
  hasHeader?: boolean;
}

export function ListingSkeleton({ count, hasHeader = true }: IListingSkeletonProps) {
  return (
    <div className={styles['root']}>
      {hasHeader && (
        <div className={styles['listing-header']}>
          <div className={cn(styles['listing-header-title'], styles['skeleton'])} />
          <div className={cn(styles['close-button'], styles['skeleton'])} />
        </div>
      )}
      {Array.from({ length: count }).map((_, index) => (
        <CardSkeleton key={index} />
      ))}
    </div>
  );
}
